import now from './now.js';

export default {
  now
};



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/date.default.js
// module id = 744
// module chunks = 0